import { Controller } from "@hotwired/stimulus"
import PhotoSwipeLightbox from 'photoswipe/lightbox';

export default class extends Controller {

  static targets = ['image']

  connect() {

  const lightbox = new PhotoSwipeLightbox({
      gallery: '#product-gallery',
      children: 'a',
      initialZoomLevel: 'fit',
      secondaryZoomLevel: 0,
      maxZoomLevel: 1,
      pswpModule: () => import('photoswipe')
    });
    lightbox.init();
  }

  show(event) {
    const image = document.querySelector(`#${event.params.imageId}`)

    if ( image ) {
      if ( !image.classList.contains('active') ) {
        this.imageTargets.forEach(img => img.classList.remove('active'))
        image.classList.add('active')
      }
    }
  }
}
